module.exports = __webpack_public_path__ + "static/img/unit_tibg2.c3d3dc2f.png";